// CAR_STORY_KAKAO_TEMPLATE_ID 정본은 @/entities/content 로 이동 — 하위호환 re-export
export { CAR_STORY_KAKAO_TEMPLATE_ID } from '@/entities/content'

export const getCarStoryShareUrl = (contentId: number) =>
  `${process.env.NEXT_PUBLIC_WEB_SERVICE_URL}${process.env.NEXT_PUBLIC_BASE_PATH}/car-story/contents/${contentId}`

/** 공유 채널 트래킹 이벤트 라벨 — 공유 섹션/바텀시트가 공유 */
export const CAR_STORY_SHARE_CHANNEL = {
  KAKAO: '카카오톡',
  LINK: '링크복사',
  MORE: '더보기',
} as const

/** 카카오톡 공유 라운드 버튼 이미지 (공유 섹션/바텀시트 공통) */
export const KAKAO_SHARE_BUTTON_IMAGE_URL =
  'https://mycle.co.kr/post/images/product/share_round_btn_kakao.png'
